<div fxLayout="column" fxLayoutAlign="center center" class="crm-incall-actions" *ngIf="activeCRM?.is_authenticated">
  <div class="crm-logo" *ngIf="crmType">
    <img class="crm-logo-image" src="assets/images/{{crmType.logo}}">
  </div>
  <div>
    <h3 class="title">
      {{(isEdit?'crm.recall_actions.contact_found':'crm.recall_actions.contact_not_found')|translate}}
    </h3>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
    <div *ngIf="crmClientName">{{ crmClientName }}</div>
    <div fxLayout="row" fxLayoutGap="10px">
      <a [ngClass]="{'action':showDisplayEditContact, 'action-disabled':!showDisplayEditContact}"
        (click)="showDisplayEditContact?updateContact():doNothing()">
        <b>{{(isEdit?'public.edit':'public.create')|translate}}</b>
      </a>

      <a [ngClass]="{'action':showDisplayCreateTask, 'action-disabled':!showDisplayCreateTask}" [class.disabled]="isEdit"
        (click)="showDisplayCreateTask?createTask():doNothing()">
        <b>{{'crm.action.recall'|translate}}</b>
      </a>
    </div>
  </div>
  <div fxLayout="row" fxLayoutGap="50px" fxLayoutAlign="center center" class="history-container">
    <app-crm-contact-history [activeCall]="activeCall"></app-crm-contact-history>
  </div>
</div>
